import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Box
} from '@mui/material';

const BalanceSheetForm = ({ open, onClose, onSubmit, editingItem = null }) => {
  const [formData, setFormData] = useState({
    type: 'asset',
    category: 'cash',
    owner: 'Primary',
    name: '',
    amount: '',
    notes: '',
    date: new Date().toISOString().split('T')[0]
  });

  useEffect(() => {
    if (editingItem) {
      setFormData({
        ...editingItem,
        date: editingItem.date ? new Date(editingItem.date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
        amount: editingItem.amount.toString()
      });
    } else {
      setFormData({
        type: 'asset',
        category: 'cash',
        owner: 'Primary',
        name: '',
        amount: '',
        notes: '',
        date: new Date().toISOString().split('T')[0]
      });
    }
  }, [editingItem]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitting form data:', formData);
    const submissionData = {
      ...formData,
      amount: parseFloat(formData.amount),
      date: formData.date ? new Date(formData.date).toISOString() : new Date().toISOString()
    };
    console.log('Processed submission data:', submissionData);
    onSubmit(submissionData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{editingItem ? 'Edit Item' : 'Add New Item'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              type="date"
              label="Date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              select
              label="Type"
              name="type"
              value={formData.type}
              onChange={handleChange}
              fullWidth
              required
            >
              <MenuItem value="asset">Asset</MenuItem>
              <MenuItem value="liability">Liability</MenuItem>
            </TextField>

            <TextField
              select
              label="Owner"
              name="owner"
              value={formData.owner}
              onChange={handleChange}
              fullWidth
              required
            >
              <MenuItem value="Primary">Primary</MenuItem>
              <MenuItem value="Partner">Partner</MenuItem>
              <MenuItem value="Joint">Joint</MenuItem>
            </TextField>

            <TextField
              select
              label="Category"
              name="category"
              value={formData.category}
              onChange={handleChange}
              fullWidth
              required
            >
              {formData.type === 'asset' ? [
                <MenuItem key="cash" value="cash">Cash</MenuItem>,
                <MenuItem key="investments" value="investments">Investments</MenuItem>,
                <MenuItem key="property" value="property">Property</MenuItem>,
                <MenuItem key="vehicles" value="vehicles">Vehicles</MenuItem>,
                <MenuItem key="superannuation" value="superannuation">Superannuation</MenuItem>,
                <MenuItem key="other" value="other">Other</MenuItem>
              ] : [
                <MenuItem key="credit_cards" value="credit_cards">Credit Cards</MenuItem>,
                <MenuItem key="loans" value="loans">Loans</MenuItem>,
                <MenuItem key="mortgage" value="mortgage">Mortgage</MenuItem>,
                <MenuItem key="other" value="other">Other</MenuItem>
              ]}
            </TextField>

            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              required
            />

            <TextField
              label="Amount"
              name="amount"
              type="number"
              value={formData.amount}
              onChange={handleChange}
              fullWidth
              required
            />

            <TextField
              label="Notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">
            {editingItem ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default BalanceSheetForm; 